import React, { useState, useEffect, useId } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import TextField from "@mui/material/TextField";
import Layout from "./layout";
import axios from "axios";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import UserForm from "./userForm";
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
// import SearchBox from "./searchbox";
import TableSortLabel from "@mui/material/TableSortLabel";
import { alpha } from "@mui/material/styles";
import InputAdornment from '@mui/material/InputAdornment';
import { IconButton } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

import '../App.css';
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Container = styled("div")({
  padding: "5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
});

const ModalStyle = {
  position: "absolute",
  borderRadius: "5px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  pb:1,
  pr:1,
  color:'black'
};

export default function UserManagement() {
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchQuery, setSearchQuery] = useState("");
  const [error, setError] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [isUserFormOpen, setIsUserFormOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteMsg, setDeleteMsg] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [userId, setUserId] = useState();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("user_id");

  const handleModelClose = () => {
    setIsUserFormOpen(false);
    setSelectedUser(null);
  };

  const navigate = useNavigate();
  useEffect(() => {
    const fetchUserData = async () => {
   
      const email = localStorage.getItem('user_email');
      try {
    const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`, 
          { email },
          { headers: { 'user_email': email }},
        );
    
        if (response.status === 200) {
          setUserId(response.data.user.user_id);
          console.log("response", response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  

  useEffect(() => {
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/user/getusers", 
        { withCredentials: true }
      );
      setRows(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      
      // Handling unauthorized access
      if (error.response && error.response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect to Sign-In page if unauthorized
        return; // Stop further execution
      }
  
      setError("Failed to fetch user data.");
    }
  };
  
  //Arohi
  //Added delete Snackbar
  const handleDelete = () => {
    if (selectedRows.length === 0) {
      setDeleteMsg("Please select users before deleting.");
      setIsConfirmationOpen(true);

      return;
    }
    setDeleteMsg("Are you sure you want to delete the selected user?");
    setIsConfirmationOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.post(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/user/deleteusers",
        { userIds: selectedRows ,
          updatedby: userId
        }
      );
      setRows(rows.filter((row) => !selectedRows.includes(row.user_id)));
      setSelectedRows([]);
      setIsConfirmationOpen(false);
      setSnackbarMessage("User deleted successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      
    } catch (error) {
      console.error("Error deleting users:", error);
       // Handling unauthorized access (401 error)
    if (error.response && error.response.status === 401) {
      console.log("Unauthorized access, redirecting to Sign-In...");
      navigate("/signin"); // Redirect to Sign-In page if unauthorized
      return; // Stop further execution
    }
      setSnackbarMessage("Cannot delete user. User data is associated with one or more sections.");
      setSelectedRows([]);
      setIsConfirmationOpen(false);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const cancelDelete = () => {
    setIsConfirmationOpen(false);
    setSelectedRows([]);

  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.user_id);
      setSelectedRows(newSelecteds);
      return;
    }
    setSelectedRows([]);
  };

  const handleCheckboxClick = (event, user_id) => {
    const selectedIndex = selectedRows.indexOf(user_id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedRows, user_id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedRows.slice(1));
    } else if (selectedIndex === selectedRows.length - 1) {
      newSelected = newSelected.concat(selectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedRows.slice(0, selectedIndex),
        selectedRows.slice(selectedIndex + 1)
      );
    }

    setSelectedRows(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleSortRequest = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const filteredRows = rows.filter((row) => {
    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean); // Split on spaces and remove empty strings
  
    return searchTerms.every((term) =>
      (row.first_name && row.first_name.toLowerCase().includes(term)) ||
      (row.last_name && row.last_name.toLowerCase().includes(term)) ||
      (row.user_id && row.user_id.toString().toLowerCase().includes(term)) ||
      (row.role_name && row.role_name.toLowerCase().includes(term)) ||
      (row.contact_no && row.contact_no.toString().includes(term)) ||
      (row.email_id && row.email_id.toLowerCase().includes(term))
    );
  });
  const sortedRows = filteredRows.sort((a, b) => {
    if (orderBy === "user_id") {
      return (order === "asc" ? 1 : -1) * (a[orderBy] - b[orderBy]);
    } else {
      return (order === "asc" ? 1 : -1) * a[orderBy].localeCompare(b[orderBy]);
    }
  });

  const paginatedRows = sortedRows.slice(  
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );



  const handleEdit = (id) => {
    const userId = id;
    axios
      .get(
        process.env.REACT_APP_JHS_DEVELOPMENT +
          `/student/getuserdetails?user_id=${userId}`, { withCredentials: true }
      )
    
      
      .then((response) => {
        setSelectedUser(response.data);
        setIsUserFormOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching user details:", error);
      });
  };

  const handleSnackbar = (msg, severity) => {
    setSnackbarSeverity(severity);
    setSnackbarMessage(msg);
    setSnackbarOpen(true);
  };

  return (
    <>
      <Layout />
      <h1 className="title">Manage Users</h1>

      <Container>
        <div className="user_management_container" >
          <div style={{ display: "flex", marginBottom:'6px' }}>
            <TextField
              sx={{ minWidth: 300, mt: 0, mb: 0, pt: 0, pb: 0 }}
              label="Search..."
              variant="outlined"
              fullWidth
              value={searchQuery}
              onChange={handleSearchChange}
              size="small"
              // className="user_management_container_searchbar"
              style={{ marginBottom: "0", border: "none" }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton type="button" aria-label="search">
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div> 
          <div className="user_mngmt_add_delete_container">
            <Button
              onClick={handleDelete}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "5px",
              }}
            >
              {" "}
              Delete{" "}
            </Button>
            <Button
              className="blue-btn"
              onClick={() => setIsUserFormOpen(true)}
            >
              Add New User
            </Button>
          </div>
        </div>
        {error && <p style={{ color: "red" }}>{error}</p>}

        <TableContainer component={Paper}>
          <div
        
           >
            <Table>
              <TableHead
               
              >
                <TableRow
                
                >
                  <StyledTableCell padding="checkbox" 
                  // sx={{ width: "5%", textAlign:'center' }}
                  >
                    <Checkbox
                      style={{ color: "#fff" }}
                      indeterminate={
                        selectedRows.length > 0 &&
                        selectedRows.length < rows.length
                      }
                      checked={
                        rows.length > 0 && selectedRows.length === rows.length
                      }
                      onChange={handleSelectAllClick}
                      inputProps={{ "aria-label": "select all users" }}
                    />
                  </StyledTableCell>

                  {[
                    { id: "user_id", label: "User Id" },
                    { id: "first_name", label: "User Name" },
                    { id: "role_name", label: "Role" },
                    { id: "contact_no", label: "Contact No" },
                    { id: "email_id", label: "Email Id" },
                  ].map((column) => (
                    <StyledTableCell
                      key={column.id}
                      align="center"
                      onClick={() => handleSortRequest(column.id)}
                      sx={{
                        // position: "sticky",
                        width: "20%", // Fixed width for consistency
                        padding: "8px", // Adequate padding for stability
                        position: "relative",
                        height: "60px", // Ensure header cells match the row height
                        "& .MuiTableSortLabel-root": {
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                          height: "100%", // Ensure sort label spans the full height
                          boxSizing: "border-box", // Ensures padding and border are included in the height
                        },
                        "& .MuiTableSortLabel-icon": {
                          marginLeft: "8px", // Space between text and icon
                          position: "relative",
                          top: "2px", // Adjust vertical alignment if needed
                        
                        },
                        "&:hover .MuiTableSortLabel-root": {
                          color: "black", // Hover color
                          position: "sticky",
                        },
                        "& .Mui-active": {
                          color: "white", // Active color
                          position: "sticky",
                        },
                      }}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={orderBy === column.id ? order : "asc"}
                      >
                        {column.label}
                      </TableSortLabel>
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedRows.map((row) => (
                  <StyledTableRow
                    key={row.user_id}
                    t
                    hover
                    sx={{
                      cursor: "pointer",paddingRight:'30px',
                      textAlign:'center',
                      "&:hover": {
                        backgroundColor: (theme) =>
                          alpha(theme.palette.primary.light, 0.25),
                      },
                    }}
                  >
                    <StyledTableCell padding="checkbox" style={{textAlign:'center'}}>
                      <Checkbox
                        color="primary"
                        checked={selectedRows.indexOf(row.user_id) !== -1}
                        onChange={(event) =>
                          handleCheckboxClick(event, row.user_id)
                        }
                        inputProps={{
                          "aria-label": `select user ${row.user_id}`,
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell 
                      align="center"  style={{ cursor: "pointer",paddingRight:'30px' }}
                      component="th"
                      scope="row"
                      onClick={() => handleEdit(row.user_id)}
                    >
                      {row.user_id}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ cursor: "pointer",paddingRight:'30px' }}
                      onClick={() => handleEdit(row.user_id)}
                    >
                      {row.first_name + " " + row.last_name}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ cursor: "pointer", paddingRight:'30px'}}
                      onClick={() => handleEdit(row.user_id)}
                    >
                      {row.role_name}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"

                      style={{ cursor: "pointer",paddingRight:'30px' }}
                     

                      onClick={() => handleEdit(row.user_id)}
                    >
                      {row.contact_no}
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      style={{ cursor: "pointer",paddingRight:'30px' }}
                      onClick={() => handleEdit(row.user_id)}
                    >
                      {row.email_id}
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          

          <TablePagination
            style={{ background: "#0A64A2", color: "#fff" }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Container>

      {/* Confirmation Modal */}
      <Modal open={isConfirmationOpen} onClose={cancelDelete}>
        <Box sx={ModalStyle} >
          <Typography sx={{fontSize:'1.1em', color:'#0A64A2'}} >
            {deleteMsg}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
            
            {selectedRows.length === 0 ? (
              ""
            ) : (
              <Button  variant='contained' onClick={confirmDelete} className="no-btn" >
                Yes
              </Button>
            )}
            <Button variant= 'contained' onClick={cancelDelete} className="no-btn ">
                   {deleteMsg === "Please select users before deleting." ? "Ok" : "No"}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* User Form Modal */}
      <Modal open={isUserFormOpen} onClose={handleModelClose}>
        <div>
          <UserForm
            setSelectedUser={setSelectedUser}
            handleSnackbar={handleSnackbar}
            userData={selectedUser}
            getUsers={getUsers}
            handleModelClose={handleModelClose}
          />
          {/* <SearchBox handleSnackbar={handleSnackbar} /> */}
        </div>
      </Modal>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          // onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ alignItems: "center", width: "100%" }}
          variant="filled"
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
